import { Input } from 'antd';
import { SearchProps } from 'antd/es/input';
import { FC } from 'react';

import styles from './styles.module.scss';

export const CustomSearchInput: FC<SearchProps> = (props) => {
    return (
        <Input.Search
            className={styles['search-input']}
            placeholder="Search"
            allowClear
            {...props}
        />
    );
};
